import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link} from "react-router-dom";

import {toast} from "react-toastify";
import axios from "axios";
import Cookies from "js-cookie";




@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Login extends Component {

    constructor(props) {
        super(props);
        this.state={
            email:"",

            emailInvalid: false,
            password: "",
            otp: "",
            loader: false,
            otpShow: false,
        }
        this.login=this.login.bind(this);
        this.loginEnter=this.loginEnter.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeOTP = this.onChangeOTP.bind(this);

    }

    loginRequest(){
        this.setState({
            loader:true
        });
        const defaultHeaders = {
            'content-type' : 'application/x-www-form-urlencoded',
        }
        var _that=this;
        var formData = new FormData();
        formData.append("email", this.state.email);
        formData.append("hv_token", (typeof Cookies.get('hv_token')==="undefined") ? "" : Cookies.get('hv_token'));
        formData.append("password", this.state.password);
		
		if(this.state.otpShow == false){
			
			
			
			
		axios.post(this.props.chatprop.url + "sendPhoneCode", formData, {
            headers: defaultHeaders,
        }).then((response) => {
            if (response.status === 200) {
                _that.setState({
                    loader:false
                });
                if (response.data.message.status == false) {
                    if (typeof response.data.message.error !== "undefined") {
                        $.each(response.data.message.error, function (k, v) {
                            toast.error(v);
                        });
                        return false;
                    }
                } else if (response.data.message.status == true) {
                    if (typeof response.data.message.success !== "undefined") {
			this.setState({
            otpShow:true
			});
                        return true;
						
                    }
                }
            }
        });
		
		
		
			
			
		}else{
			
		formData.append("otp", this.state.otp);	
		axios.post(this.props.chatprop.url + "login", formData, {
            headers: defaultHeaders,
        }).then((response) => {
            if (response.status === 200) {
                _that.setState({
                    loader:false
                });
                if (response.data.message.status == false) {
                    if (typeof response.data.message.error !== "undefined") {
                        $.each(response.data.message.error, function (k, v) {
                            toast.error(v);
                        });
                        return false;
                    }
                } else if (response.data.message.status == true) {
                    if (typeof response.data.message.success !== "undefined") {
                        if(typeof response.data.message.data.token!=="undefined"){
                            Cookies.set('hv_token',response.data.message.data.token);
                        }
                        window.location.reload();
                      //  window.location.href=_that.props.chatprop.url+"welcome/installation";
                        return false;
                    }
                }
            }
        });
			
			
		}
		
		
		
    }
    loginEnter(e){

        if (e.key === "Enter") {
            this.loginRequest();
        }
    }
    login(){
        this.loginRequest();

    }

    onChangeEmail(e) {
        if(this.emailValidation(e.target.value)){
            this.setState({
                email : e.target.value,
                emailInvalid:false
            });
        } else{
            this.setState({
                emailInvalid : true
            });

        }

    }
    onChangePassword(e){
        this.setState({
            password : e.target.value.trim(),
        });

    }
	onChangeOTP(e){
        this.setState({
            otp : e.target.value.trim(),
        });

    }
    emailValidation(email){
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if(!email || regex.test(email) === false){
            return false;
        }
        return true;
    }

    render() {
        const { t } = this.props;
        return (

            <div className="auth-wrap">
                <div className="auth-content">
                    <div className="auth-body auth-middle">
                        <div className="auth-logo pb-4 text-center">
                            <div className="auth-logo-wrap">
                                <img
                                    src={`/Public/images/logo-128-39.png`} alt="logo" />
                            </div>
                        </div>
                        <div className="auth-card auth-card-preview">
                            <div className="auth-card-inner auth-card-inner-lg">
                                <div className="auth-block-head">
                                    <div className="auth-block-head-title">Login</div>
                                    <div className="auth-block-head-description">

                                    </div>
                                </div>

                                    <div className="auth-form-group">
                                          <div className="auth-label-group">
                                              <label className="auth-label">Email</label>
                                          </div>
                                        <div className="auth-form-wrap">
                                            <input type="text"
                                                   onChange={this.onChangeEmail.bind(this)}
                                                   onKeyPress={this.loginEnter}
                                                   className="auth-form-control-lg auth-form-control"
                                                   placeholder="ad@example.com" />
                                            {this.state.emailInvalid === true &&
                                                 <div className="auth-input-error">Invalid Email</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="auth-form-group">
                                          <div className="auth-label-group">
                                              <label className="auth-label">Password</label>
                                          </div>
                                        <div className="auth-form-wrap">
                                            <input type="password"
                                                   onChange={this.onChangePassword.bind(this)}
                                                   placeholder="******"
                                                   onKeyPress={this.loginEnter}
                                                   className="auth-form-control-lg auth-form-control"  />
                                        </div>
                                    </div>
									{this.state.otpShow === true &&
									<div className="auth-form-group">
                                          <div className="auth-label-group">
                                              <label className="auth-label">OTP Code</label>
                                          </div>
                                        <div className="auth-form-wrap">
											<input 
											onChange={this.onChangeOTP.bind(this)}
											onKeyPress={this.loginEnter}
											type="text"
											class="auth-form-control-lg auth-form-control"
											placeholder="******"
											/>
                                        </div>
                                    </div>
									}
                                    <div className="auth-form-group">
                                        <button className="btn btn-primary btn-lg btn-block"
                                                disabled={this.state.loader}
                                                onClick={this.login.bind(this)}

                                                type="submit">
                                            {this.state.loader === true &&
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            }
                                            {this.state.loader === false &&
                                            <span>Login</span>
                                            }
                                        </button>
                                    </div>
                                    <div className="auth-form-note text-center pt-4">
                                        Don't have an account?&nbsp;<Link to={"/signup"}>Create an account</Link>
                                    </div>


                            </div>
                        </div>
                    </div>
                    <div className="auth-footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center"><p
                                        className="auth-footer-text">© {new Date().getFullYear()} HelperVia. All Rights Reserved.</p></div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

export default Login;
